import InputSlider from '@/components/sections/builder/settings/input-slider';

import { ThemeMediaType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_MEDIA = {
  borderThickness: 0,
  borderOpacity: 0,
  borderCornerRadius: 0,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 0,
  shadowBlur: 0,
};

export default function BrandInfoSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const media = builder.theme?.media || DEFAULT_THEME_MEDIA;

  const setStyle = (newMedia: Partial<ThemeMediaType>) => {
    builder.setTheme({
      media: { ...media, ...newMedia },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={media.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setStyle({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={media.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setStyle({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={media.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setStyle({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <p className='text-sm'>Affects areas with multiple columns or rows.</p>
      <InputSlider
        label='Opacity'
        value={media.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setStyle({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={media.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setStyle({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={media.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setStyle({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={media.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setStyle({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
    </div>
  );
}
